const ACTIVE_SIZE = "4fr";
const INACTIVE_SIZE = "1fr";

export const initGallery = () => {

    document.querySelectorAll("section.gallery").forEach(section => {
        initGallerySection(section);
    });

};

export const initGallerySection = section => {

    const gallery = section.querySelector(".cell.--right");
    const slides = [...section.querySelectorAll(".cell.--right > .img-wrapper[data-gallery-slide]")];
    const currentElement = section.querySelector("[data-gallery-current]");
    const totalElement = section.querySelector("[data-gallery-total]");
    const labelElement = section.querySelector("[data-gallery-label]");
    const previousButton = section.querySelector("[data-gallery-prev]");
    const nextButton = section.querySelector("[data-gallery-next]");

    if (!gallery || slides.length <= 1) {
        return;
    }

    const totalSlides = slides.length;
    let activeIndex = slides.findIndex(slide => slide.dataset.galleryActive === "true");

    if (activeIndex < 0) {
        activeIndex = 0;
    }

    const formatSlideNumber = slideIndex => {
        return String(slideIndex + 1).padStart(2, "0");
    };

    const buildColumns = nextActiveIndex => {

        return slides
            .map((_, index) => index === nextActiveIndex ? ACTIVE_SIZE : INACTIVE_SIZE)
            .join(" ");

    };

    const setActiveSlide = requestedIndex => {

        activeIndex = (requestedIndex + totalSlides) % totalSlides;

        gallery.classList.add("has-active-slide");
        gallery.style.setProperty("--gallery-columns", buildColumns(activeIndex));

        slides.forEach((slide, index) => {

            const isActive = index === activeIndex;

            slide.classList.toggle("is-active", isActive);
            slide.dataset.galleryActive = isActive ? "true" : "false";

        });

        if (currentElement) {
            currentElement.textContent = formatSlideNumber(activeIndex);
        }

        if (totalElement) {
            totalElement.textContent = String(totalSlides).padStart(2, "0");
        }

        if (labelElement) {
            labelElement.textContent = slides[activeIndex]?.dataset.galleryLabel || "";
        }

    };

    const bindButton = (button, direction) => {

        if (!button || button.dataset.galleryBound === "true") {
            return;
        }

        button.addEventListener("click", () => {
            setActiveSlide(activeIndex + direction);
        });

        button.addEventListener("keydown", event => {

            if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                event.preventDefault();
                setActiveSlide(activeIndex - 1);
            }

            if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                event.preventDefault();
                setActiveSlide(activeIndex + 1);
            }

        });

        button.dataset.galleryBound = "true";

    };

    const bindSlide = (slide, index) => {

        if (!slide || slide.dataset.galleryInteractionBound === "true") {
            return;
        }

        slide.addEventListener("mouseenter", () => {
            setActiveSlide(index);
        });

        slide.addEventListener("focusin", () => {
            setActiveSlide(index);
        });

        slide.addEventListener("click", () => {
            setActiveSlide(index);
        });

        slide.dataset.galleryInteractionBound = "true";

    };

    bindButton(previousButton, -1);
    bindButton(nextButton, 1);
    slides.forEach(bindSlide);
    setActiveSlide(activeIndex);

};
